import { useRef} from 'react';
import { encryptMessage } from '../common/services/proxyServices';

export const useFormSubmit = (encodedMessage) => {
  const formRef = useRef(null);
  const inputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const encrypted = await encryptMessage(encodedMessage);
      if (inputRef.current) {
        inputRef.current.value = encrypted;
      }
      setTimeout(() => {
        if (formRef.current) {
          formRef.current.submit();
        }
      }, 0);
    } catch (error) {
      throw new Error(error);
    }
  };

  return { formRef, inputRef, handleSubmit };
};